<template>
  <Modal
    :modal-style="{ width: '60vw', maxWidth: '60vw' }"
    :title="title"
  >
    <div
      class="tw:flex tw:h-full tw:flex-col tw:overflow-auto tw:p-4 tw:will-change-scroll"
    >
      <QSpinner
        v-if="loading"
        class="absolute-center"
        size="50"
      />

      <div v-else>
        <div class="q-mb-md">
          <h3>API Token</h3>
          <CopyToClipboardInput
            label="API Token"
            :model-value="userApiToken"
          />
          <p v-if="userApiToken">
            This token cannot be retrieved again. Please copy it send to the
            customer immediately.
          </p>
        </div>
      </div>
    </div>

    <template #buttons>
      <BaseButton
        color="primary"
        :disabled="tokenCreated"
        label="Create API Token"
        new-design
        @click="createApiToken"
      />
      <BaseButton
        color="white"
        :label="$t('global.close')"
        new-design
        @click.prevent="cancel"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

import CopyToClipboardInput from "src/components/common/CopyToClipboardInput.vue";

export default {
  name: "UserApiModal",
  components: {
    BaseButton,
    CopyToClipboardInput,
    Modal,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ["cancel"],
  data() {
    return {
      userApiToken: null,
      tokenCreated: false,
      loading: false,
    };
  },
  computed: {
    title() {
      return `${this.user.name}'s API Token`;
    },
  },
  methods: {
    async createApiToken() {
      try {
        this.loading = true;

        const response = await this.$streemApiAdmin.post(
          `users/${this.user.id}/api_token`,
          { params: { user_id: this.user.id } }
        );

        this.tokenCreated = true;
        this.userApiToken = response.data.token;
      } catch (error) {
        this.$error("Unable to create API Token", error);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
